import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Start = _resolveComponent("Start")!
  const _component_Personal = _resolveComponent("Personal")!
  const _component_Simulations = _resolveComponent("Simulations")!
  const _component_Research = _resolveComponent("Research")!
  const _component_Projects = _resolveComponent("Projects")!
  const _component_Blog = _resolveComponent("Blog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Start),
    _createElementVNode("main", null, [
      _createVNode(_component_Personal),
      _createVNode(_component_Simulations),
      _createVNode(_component_Research),
      _createVNode(_component_Projects),
      _createVNode(_component_Blog)
    ])
  ]))
}